import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HeroHeader from "./components/HeroHeader";
import HeroFooter from "./components/HeroFooter";
import HeroHomePage from "./pages/HeroHomePage";
import WorkPage from "./pages/WorkPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <HeroHeader />
        <Routes>
          <Route path="/" element={<HeroHomePage />} />
          <Route path="/work" element={<WorkPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        <HeroFooter />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
